import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-contact-details',
  templateUrl: './app-contact-details.component.html'
})
export class AppContactDetailsComponent {

  /**
   * The formData that is being passed between each sub-component which
   * will eventually be posted to the remote service.
   */
  @Input()
  formData: any;

  public validPhoneNumber(number: string, type: string): boolean {
    if (number.length <= 0) {
      return true;
    }

    if (type === 'mobile') {
      return number === undefined || number === null || number.length === 0 || /^07\d{9}$/.test(number);
    } else if (type === 'landline') {
      return number === undefined || number === null || number.length === 0 || /^0[12]\d{8,9}$/.test(number);
    } else {
      return true;
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/contact-details/app-contact-details.component.ts